import FormNumberInput from 'components/new-ui/composed/formInput/FormNumberInput';

type Props = {
    disabled?: boolean;
};

const DueDateAlertsField = ({ disabled }: Props) => {
    return (
        <FormNumberInput
            placeholder="Enter days"
            name="dueDateAlert.amount"
            integerOnly
            min={1}
            step={1}
            max={365 * 5}
            disabled={disabled}
        />
    );
};

export default DueDateAlertsField;
